
export const getLanguage = () => localStorage.getItem('language') || 'se';

export const setLanguage = lang => localStorage.setItem('language', lang);
